import {
  AssignPlatformPayload,
  AssignPlatforms,
  User,
  Payload,
  BrandPayload,
  StorePayload,
  AssignPlatformSubmitForm,
  Brands,
  Platforms,
} from "./../models/assignPlatform";
import axiosClient from "./axiosClient";
import { ApiResponse } from "models";

const assignPlatformApi = {
  getAllAssignedAggregatorPlatforms(
    data: AssignPlatformPayload
  ): Promise<AssignPlatforms> {
    return axiosClient.get(`assignAggrigatorPlatform/getAllAssignedAggrigatorPlatform`, {
      params: {
        limit: data.limit,
        page: data.page,
        search: data.search,
        sortField: data.sortName,
        sortType: data.sortType,
      }
    });
  },
  getCustomersList(data: Payload): Promise<User> {
    return axiosClient.get(`/customer/getAllCustomer`, {
      params: { disablePagination: data.disablePagination }
    });
  },
  getBrandsList(data: BrandPayload): Promise<Brands> {
    return axiosClient.get(`/brand/getBrandByCustomerId`, {
      params: { customerID: data }
    });
  },
  getStoresList(data: StorePayload): Promise<Brands> {
    return axiosClient.get(`/store/getStoreByBrandId`, {
      params: { brandId: data }
    });
  },
  getPlatformsList(data: Payload): Promise<Platforms> {
    return axiosClient.get(`/store/getStorePlatform`, {
      params: { disablePagination: data.disablePagination }
    });
  },

  addAssignAggregatorPlatform(
    data: AssignPlatformSubmitForm
  ): Promise<ApiResponse> {
    return axiosClient.post(`/assignAggrigatorPlatform/addAssignAggrigatorPlatform`, data);
  },

  updateAssignAggregatorPlatform(
    data: AssignPlatformSubmitForm
  ): Promise<ApiResponse> {
    return axiosClient.put(`/assignAggrigatorPlatform/updateAssignedAggrigatorPlatform`, data);
  },

  deleteAssignAggregatorPlatform(data: any): Promise<ApiResponse> {
    return axiosClient.delete(`/assignAggrigatorPlatform/deleteAssignedAggrigatorPlatform`, {
      params: {
        platformName: data.platformName,
        storeId: data.id,
      }
    });
  },
};

export default assignPlatformApi;
